import React, { useEffect } from 'react';
import { IProps } from './types';
import _ from 'lodash';
import { EndorseOption, MortgageInfo } from 'constants/models/endorseOption';
import { EndorseOptContent, EndorseOptContentData, EndorseOptContentTarget } from 'bff/models/member';
import { EndorseAttachmentType } from 'constants/enums/endorseAttachmentType';
import { EndorseType } from 'constants/enums/endorseType';
import commonService from 'utils/commonService';
import { EndorseTarget } from 'constants/enums/endorseTarget.enum';
import { MortgageBankContent } from 'bff/models/info';
import { YesNo, YesNoType } from 'constants/enums/yesNo.enum';

const PreviewFire: React.FC<IProps> = (props) => {
    /**
     * 建立變更項目區塊
     */
    const handleCreateItems = () => {
        if (!props.editedEndorseItems || props.editedEndorseItems.length === 0) return;

        const editItems = _.filter(props.editedEndorseItems, (item: EndorseOption) => item.CHECKED);
        if (!editItems || editItems.length === 0) return;

        let titleClass = "correction-preview__correction-content-item-title";

        return _.map(editItems, (editItem: EndorseOption, editItemIndex: number) => {
            // 原始項目
            const originalItem = _.find(props.originalEndorse.OPTION,
                (opt: EndorseOptContent) =>
                    opt.ORDER_NO === editItem.ORDER_NO &&
                    opt.ENDORSE_TYPE === editItem.ENDORSE_TYPE &&
                    opt.DATA_TYPE === editItem.DATA_TYPE
            );

            if (!originalItem) return;

            if (editItemIndex > 0) {
                titleClass = "correction-preview__correction-content-item-mobile-title";
            }

            return (
                <div className="correction-preview__correction-content" key={editItemIndex}>
                    <div className="correction-preview__correction-content-title">{commonService.htmlParser(`${editItem.ORDER_NO}.${editItem.TYPE_NAME}`)}</div>
                    <div className="correction-preview__correction-content-item">
                        {
                            editItem.ENDORSE_TYPE !== EndorseType.ADD_MORTGAGE
                                ? (
                                    <>
                                        <div className="correction-preview__correction-content-item-content">
                                            <p className={titleClass}>修改前</p>
                                            <div>{handleGetOriginaItemlVal(originalItem)}</div>
                                        </div>
                                        <div className="correction-preview__correction-content-item-content">
                                            <p className={titleClass}>修改後</p>
                                            <div>{commonService.htmlParser(handleGetEditItemVal(editItem, originalItem))}</div>
                                            {
                                                editItem.ATTACHMENT === EndorseAttachmentType.Required && (
                                                    <img src={editItem.FILE_BASE64} alt={editItem.TYPE_NAME} />
                                                )
                                            }
                                        </div>
                                    </>
                                )
                                : (
                                    <>
                                        <div className="correction-preview__correction-content-item-content">
                                            <p className={titleClass}>修改前</p>
                                            {
                                                _.map(originalItem.DATA, (data: EndorseOptContentData, dataIndex: number) => {
                                                    return (
                                                        <div className="mortgage-content" key={dataIndex}>
                                                            <div className="mortgage-item">
                                                                <p className="mortgage-item-title">抵押權人</p>
                                                                <p>{handleGetMortgageBankName(data.HDR_ID, data.HBRCH_ID)}</p>
                                                            </div>
                                                            <div className="mortgage-item">
                                                                <p className="mortgage-item-title">保單正本及收據副本是否寄送抵押銀行</p>
                                                                <p>{handleGetDeliveryType(data.DELIVER_BANK)}</p>
                                                            </div>
                                                            <div className="mortgage-item mortgage-item-bottom">
                                                                <div>
                                                                    <p className="mortgage-item-title">銀行經辦收件人</p>
                                                                    <p>{data.OPERATOR}</p>
                                                                </div>
                                                                <div>
                                                                    <p className="mortgage-item-title">銀行收件地址</p>
                                                                    <p>
                                                                        {
                                                                            `${commonService.getCityName(props.postCodes, data.CITY_ID)}${commonService.getAreaName(props.postCodes, data.CITY_ID, data.AREA_ID)}${data.ADDRESS}`
                                                                        }
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                        <div className="correction-preview__correction-content-item-content">
                                            <p className={titleClass}>修改後</p>
                                            {
                                                editItem.MORGAGE_INFOS && editItem.MORGAGE_INFOS.length > 0 && (
                                                    _.map(editItem.MORGAGE_INFOS, (info: MortgageInfo, infoIndex: number) => {
                                                        const itemClassNames = ["mortgage-item"];
                                                        const itemBottomClassNames = ["mortgage-item", "mortgage-item-bottom"];

                                                        if (!originalItem.DATA || (infoIndex !== 0 && infoIndex + 1 > originalItem.DATA.length)) {
                                                            itemClassNames.push("mortgage-item-new");
                                                            itemBottomClassNames.push("mortgage-item-new");
                                                        }

                                                        return (
                                                            <div className="mortgage-content" key={infoIndex}>
                                                                <div className={itemClassNames.join(" ")}>
                                                                    <p className="mortgage-item-title">抵押權人</p>
                                                                    <p>{handleGetMortgageBankName(info.HDR_ID, info.HBRCH_ID)}</p>
                                                                </div>
                                                                <div className={itemClassNames.join(" ")}>
                                                                    <p className="mortgage-item-title">保單正本及收據副本是否寄送抵押銀行</p>
                                                                    <p>{handleGetDeliveryType(info.DELIVER_BANK)}</p>
                                                                </div>
                                                                <div className={itemBottomClassNames.join(" ")}>
                                                                    <div>
                                                                        <p className="mortgage-item-title">銀行經辦收件人</p>
                                                                        <p>{info.OPERATOR}</p>
                                                                    </div>
                                                                    <div>
                                                                        <p className="mortgage-item-title">銀行收件地址</p>
                                                                        <p>
                                                                            {
                                                                                `${commonService.getCityName(props.postCodes, info.CITY_ID)}${commonService.getAreaName(props.postCodes, info.CITY_ID, info.AREA_ID)}${info.ADDRESS}`
                                                                            }
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )
                                                    })
                                                )
                                            }
                                            {
                                                editItem.ATTACHMENT === EndorseAttachmentType.Required && (
                                                    <img src={editItem.FILE_BASE64} alt={editItem.TYPE_NAME} />
                                                )
                                            }
                                        </div>
                                    </>
                                )
                        }
                    </div>
                </div>
            )
        })
    }

    /**
     * @description 取得抵押權人名稱
     */
    const handleGetMortgageBankName = (hdrId: string, hbrchId: string) => {
        if (!hdrId || !props.mortgageBanks || props.mortgageBanks.length === 0) return;

        const mortgageBank = _.find(props.mortgageBanks, (bank: MortgageBankContent) => bank.HDR_ID === hdrId);
       
        if (!mortgageBank) return;
        const mortgageCodeBackSection = _.find(mortgageBank.BANK_CATEGORY, (mortgageBank) => mortgageBank.HBRCH_ID === hbrchId);
        if(mortgageCodeBackSection){
            return mortgageCodeBackSection?.HBRCH_NAME;
        }else{
            return mortgageBank.HDR_NAME;
        }
    }
    /**
     * @description 取得抵押權人資訊 (分類)
     */
    const handleGetMortgageBankCategoryName = (hdrId: string, hbrchId: string) => {

        if (!hdrId || !props.mortgageBanks || props.mortgageBanks.length === 0) return;
        const mortgageBank = _.find(props.mortgageBanks, (bank: MortgageBankContent) => bank.HDR_ID === hdrId);
        if (!mortgageBank) return;
        const mortgageCodeBackSection = _.find(mortgageBank.BANK_CATEGORY, (mortgageBank) => mortgageBank.HBRCH_ID === hbrchId);
        return mortgageCodeBackSection?.HBRCH_NAME;
    };
    /**
     * @description 取得抵押權人名稱
     */
    const handleGetDeliveryType = (type: string) => {
        if (!type) return;

        switch (type) {
            case YesNo.Yes:
            case YesNoType.Yes:
                return '是';
            case YesNo.No:
            case YesNoType.No:
                return '否';
        }
    }

    /**
     * @description 取得變更項目內容值
     */
    const handleGetEditItemVal = (editItem: EndorseOption, orginalItem: EndorseOptContent) => {
        switch (editItem.ENDORSE_TYPE) {
            case EndorseType.CONTACT_MOBILE:
                return handleFormatItem(editItem.MOBILE, orginalItem.TARGET, EndorseTarget.MOBILE);
            case EndorseType.CONTACT_ADDRESS: {
                const oriCityName = commonService.getCityName(props.postCodes, handleGetOriginalVal(orginalItem.TARGET, EndorseTarget.CITY_ID));
                const oriAreaName = commonService.getAreaName(props.postCodes, handleGetOriginalVal(orginalItem.TARGET, EndorseTarget.CITY_ID), handleGetOriginalVal(orginalItem.TARGET, EndorseTarget.AREA_ID));
                const oriAddress = handleGetOriginalVal(orginalItem.TARGET, EndorseTarget.ADDRESS);

                return `${handleBaseFormatItem(editItem.CITY_ID_NAME, oriCityName)}${handleBaseFormatItem(editItem.AREA_ID_NAME, oriAreaName)}${handleBaseFormatItem(editItem.ADDRESS, oriAddress)}`;
            }
            case EndorseType.HOUSE_NUMBER: {
                const oriCityName = commonService.getCityName(props.postCodes, handleGetOriginalVal(orginalItem.TARGET, EndorseTarget.CITY_ID));
                const oriAreaName = commonService.getAreaName(props.postCodes, handleGetOriginalVal(orginalItem.TARGET, EndorseTarget.CITY_ID), handleGetOriginalVal(orginalItem.TARGET, EndorseTarget.AREA_ID));
                const oriStreet = handleGetOriginalVal(orginalItem.TARGET, EndorseTarget.ADDRESS_RD_ST);
                const oriLN = handleGetOriginalVal(orginalItem.TARGET, EndorseTarget.ADDRESS_LN);
                const oriAly = handleGetOriginalVal(orginalItem.TARGET, EndorseTarget.ADDRESS_ALY);
                const oriNo = handleGetOriginalVal(orginalItem.TARGET, EndorseTarget.ADDRESS_NO_1);
                const oriNoOf = handleGetOriginalVal(orginalItem.TARGET, EndorseTarget.ADDRESS_NO_2);
                const oriFloor = handleGetOriginalVal(orginalItem.TARGET, EndorseTarget.ADDRESS_F_1);
                const oriFloorOf = handleGetOriginalVal(orginalItem.TARGET, EndorseTarget.ADDRESS_F_2);
                const oriNote = handleGetOriginalVal(orginalItem.TARGET, EndorseTarget.ADDRESS_NOTE);

                return commonService.getFullAddress(
                    '',
                    handleBaseFormatItem(editItem.BUILD_ADDRESS_CITY_NAME, oriCityName),
                    handleBaseFormatItem(editItem.BUILD_ADDRESS_AREA_NAME, oriAreaName),
                    handleBaseFormatItem(editItem.BUILD_ADDRESS_STREET_ID_NAME, oriStreet),
                    handleBaseFormatItem(editItem.BUILD_ADDRESS_ROADWAY, oriLN),
                    handleBaseFormatItem(editItem.BUILD_ADDRESS_ALLEY, oriAly),
                    handleBaseFormatItem(editItem.BUILD_ADDRESS_NUMBER, oriNo),
                    handleBaseFormatItem(editItem.BUILD_ADDRESS_NUMBER_OF, oriNoOf),
                    handleBaseFormatItem(editItem.BUILD_ADDRESS_FLOOR, oriFloor),
                    handleBaseFormatItem(editItem.BUILD_ADDRESS_FLOOR_OF, oriFloorOf),
                    editItem.BUILD_ADDRESS_REMARK ? handleBaseFormatItem(editItem.BUILD_ADDRESS_REMARK, oriNote) : editItem.BUILD_ADDRESS_REMARK
                );
            }
            default:
                return '';
        }
    }

    /**
     * @description 判斷是否更改值，格式化欄位
     */
    const handleFormatItem = (val: string, targets: EndorseOptContentTarget[], targetType: string) => {
        const oriVal = handleGetOriginalVal(targets, targetType);
        return handleBaseFormatItem(val, oriVal);
    }

    /**  
     * @description 比較兩字串是否一樣，格式化欄位
    */
    const handleBaseFormatItem = (curVal: string, oriVal: string) => {
        if (curVal !== oriVal) return `<span class='edit-item'>${curVal}</span>`

        return curVal;
    }

    /**
     * @description 取得未更改前的值
     */
    const handleGetOriginaItemlVal = (item: EndorseOptContent) => {
        switch (item.ENDORSE_TYPE) {
            case EndorseType.CONTACT_MOBILE:
                return handleGetOriginalVal(item.TARGET, EndorseTarget.MOBILE);
            case EndorseType.CONTACT_ADDRESS:
                return `
                ${commonService.getCityName(props.postCodes, handleGetOriginalVal(item.TARGET, EndorseTarget.CITY_ID))}
                ${commonService.getAreaName(props.postCodes, handleGetOriginalVal(item.TARGET, EndorseTarget.CITY_ID), handleGetOriginalVal(item.TARGET, EndorseTarget.AREA_ID))}
                ${handleGetOriginalVal(item.TARGET, EndorseTarget.ADDRESS)}`;
            case EndorseType.CONTACT_MOBILE:
                return handleGetOriginalVal(item.TARGET, EndorseTarget.APPLICANT_MOBILE);
            case EndorseType.HOUSE_NUMBER: {
                return commonService.getFullAddress(
                    '',
                    commonService.getCityName(props.postCodes, handleGetOriginalVal(item.TARGET, EndorseTarget.CITY_ID)),
                    commonService.getAreaName(props.postCodes, handleGetOriginalVal(item.TARGET, EndorseTarget.CITY_ID), handleGetOriginalVal(item.TARGET, EndorseTarget.AREA_ID)),
                    handleGetOriginalVal(item.TARGET, EndorseTarget.ADDRESS_RD_ST),
                    handleGetOriginalVal(item.TARGET, EndorseTarget.ADDRESS_LN),
                    handleGetOriginalVal(item.TARGET, EndorseTarget.ADDRESS_ALY),
                    handleGetOriginalVal(item.TARGET, EndorseTarget.ADDRESS_NO_1),
                    handleGetOriginalVal(item.TARGET, EndorseTarget.ADDRESS_NO_2),
                    handleGetOriginalVal(item.TARGET, EndorseTarget.ADDRESS_F_1),
                    handleGetOriginalVal(item.TARGET, EndorseTarget.ADDRESS_F_2),
                    handleGetOriginalVal(item.TARGET, EndorseTarget.ADDRESS_NOTE)
                )
            }
            default:
                return '';
        }
    }

    /**
     * @description 取得項目原始資料值
     */
    const handleGetOriginalVal = (targets: EndorseOptContentTarget[], targetType: string) => {
        return _.find(targets,
            (target: EndorseOptContentTarget) => target.ENDORSE_TARGET === targetType)?.ORG_VALUE || '';
    };

    return (
        <div className="correction-preview__correction-container">
            {
                handleCreateItems()
            }
        </div>
    )
}

export default PreviewFire;